import { render, staticRenderFns } from "./PromotionSubsetTagsName.vue?vue&type=template&id=76fd93fe&"
import script from "./PromotionSubsetTagsName.vue?vue&type=script&lang=ts&"
export * from "./PromotionSubsetTagsName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports